export enum VacancyApplicationMatch {
  NoMatch = 0,
  PartialMatch = 1,
  FullMatch = 2,
}

export interface ApplicantModel {
  id: string;
  name: string | null;
  user_id: string;
  location: string | null;
  labels: string[] | null;
  inserted: string;
  status_id: string;
  match: VacancyApplicationMatch;
  language: string | null;
}

export enum VacancyApplyAction {
  Applied = 0,
  Redirect = 1,
}

export interface VacancyApplyResultModel {
  action: VacancyApplyAction;
  redirect_url: string | null;
  applicant: ApplicantModel | null;
}
